/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DurationUnit } from '../models/duration-unit';
export interface DurationConfiguration {
  canChangeUnit?: boolean | null;
  defaultUnit?: DurationUnit;
  increment?: number | null;
}

export class DurationConfiguration {
  canChangeUnit?: boolean | null;
  defaultUnit?: DurationUnit;
  increment?: number | null;

  constructor(value: DurationConfiguration) {
    this.canChangeUnit = value?.canChangeUnit;
    this.defaultUnit = value?.defaultUnit ? Object.entries(Object.values(DurationUnit)).flatMap((x) => x).find(x => x === value.defaultUnit) as DurationUnit : undefined;
    this.increment = value?.increment;
  }
}
